import CheckoutConfirmar from "./CheckoutConfirmar";
export default CheckoutConfirmar;